export enum Volume {
  Off,
  OnlySounds,
  On,
}
